import React, { useState } from 'react'
import Nav from 'react-bootstrap/Nav';
import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import LogoIcon from '../../Assets/LogoBlack.png';
import { Button, Dropdown } from 'react-bootstrap';
import {FaBars} from 'react-icons/fa';
import {ImCross} from 'react-icons/im';
import 'animate.css';
import './navbar.css';
import { NavLink } from 'react-router-dom';
import { MdKeyboardArrowDown } from "react-icons/md";

function NewNavbar() {
    const [isOpen,Setisopen] = useState(false);
    // useEffect(() => {
    //     const href = window.location.href.substring(
    //       window.location.href.lastIndexOf('#') + 1
    //     );
    //     const element = document.getElementById(href);
    //     if (element) {
    //       element.scrollIntoView({ behavior: 'smooth' });
    //     }
    //   }, []);
    return (
        <>
            <div>
                <Navbar className="navbar_main navbar-expand-lg bg-transparent border-0 shadow-none" variant="light" expand="lg">
                    <Container fluid className="navbar-container px-0">
                        <Row className="navbar-inner-row align-items-center flex-nowrap g-2">
                            <Col xs="auto" className="navbar-logo-col flex-shrink-0">
                                <div className="logo d-flex">
                                    <NavLink to="/" className="logoLink"><img src={LogoIcon} alt="Logo" className="img-fluid" /></NavLink>
                                </div>
                            </Col>
                            <Col className="d-none d-lg-flex flex-grow-1 align-items-center justify-content-center min-w-0 navbar-nav-center">
                                <div className="buttons_group d-flex align-items-center justify-content-center min-w-0">
                                    <ul className="link_button d-flex navbar-desktop-links">
                                        {/* <li className='upload_csv'><Nav.Link  href='/#product_overview'>Product Overview</Nav.Link></li> */}
                                        <li className='upload_csv'><Nav.Link  href='/#why_nformed'>Why Nformed?</Nav.Link></li>
                                        <li className='upload_csv'>
                                            <Nav.Link href="/#testimonial">Testimonials</Nav.Link>
                                        </li>
                                        <li className='upload_csv'><Nav.Link  href='/pricing'>Pricing</Nav.Link></li>
                                        <li className='upload_csv'><Nav.Link  href='blog' className='text-decoration-none text-dark'>Blog</Nav.Link></li>
                                        <li className='upload_csv position-relative'>
                                            <Dropdown>
                                               
                                                <Dropdown.Toggle
                                                    variant="link"
                                                    id="resourcesDropdown"
                                                    className="resources-nav-toggle text-decoration-none border-0 shadow-none"
                                                >
                                                    Resources <MdKeyboardArrowDown className="ms-1" />
                                                </Dropdown.Toggle>

                                                <Dropdown.Menu className="resources-dropdown-menu" align="start">
                                                    <Dropdown.Item
                                                        as={NavLink}
                                                        to="/amazon-fba-calculator"
                                                        onClick={() => Setisopen(false)}
                                                    >
                                                        Amazon FBA Calculator
                                                    </Dropdown.Item>
                                                    <Dropdown.Item
                                                        as={NavLink}
                                                        to="/beginners-guide-to-selling-on-amazon-fba"
                                                        onClick={() => Setisopen(false)}
                                                    >
                                                        {"Beginner's Guide"}
                                                    </Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </li>
                                   
                                        
                                    </ul>
                                </div>
                            </Col>
                            <Col xs="auto" className="d-flex align-items-center flex-shrink-0 ms-auto ms-lg-0 navbar-actions">
                                <div className="dash_button ms-0">
                                        <Button variant="transparent" href={process.env.REACT_APP_BACKEND_URL} className="btn nformed-btn sign-in-btn">
                                            Sign In
                                        </Button>
                                        <Button variant="transparent" href="/sign-up" className="btn nformed-btn try-free-btn d-none d-md-inline-flex">
                                            Try Free
                                        </Button>
                                </div>
                                <div className="navbar-hamburger d-lg-none" role="button" tabIndex={0} aria-label="Open menu" onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); Setisopen(true); } }}>
                                {!isOpen ? <FaBars onClick={() => Setisopen(true)} /> : null}
                                </div>
                            </Col>
                        </Row>
                    </Container>
                    <div className={`sidebar ${isOpen ? 'active' : ''}`}>
                        <div className="sidebarlogo">
                            <img src={LogoIcon} alt="Logo" />
                            <ImCross className="sidebarCross" onClick={() => Setisopen(false)} />
                        </div>
                        <hr />
                        <ul className="menuCon">
                            <li className="menuItem" onClick={() => Setisopen(false)}><NavLink href="#product_overview" className="text-decoration-none text-dark">Product Overview</NavLink></li>
                            <li className="menuItem" onClick={() => Setisopen(false)}><Nav.Link href="#why_nformed">Why Nformed?</Nav.Link></li>
                            <li className="menuItem" onClick={() => Setisopen(false)}><Nav.Link href="#testimonial">Testimonials</Nav.Link></li>
                            <li className="menuItem" onClick={() => Setisopen(false)}><Nav.Link href="#pricing">Pricing</Nav.Link></li>
                        </ul>
                    </div>
                </Navbar>
            </div>
        </>
    )
}

export default NewNavbar
